/* jscpd:ignore-start */
import { fetchFromVolatileServer } from "../fetchFromVolatileServer";
import { getServiceURL } from "../url";

export async function postFavorite(
  userId: number,
  recipeId: number,
  action: "DELETE" | "PUT",
  locale?: string,
) {
  const url = `${getServiceURL(locale)}/user/${userId}/favoriterecipe/${recipeId}`;
  return fetchFromVolatileServer(`${url}`, {
    method: action,
    headers: {
      // Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    credentials: "include",
    //   body: JSON.stringify({ user_id, rezept_id, bewertung_stars, token }),
  })
    .then((res) => {
      if (!res.ok) {
        console.error("Response not ok for", url, res.status);
        throw new Error("Response not ok");
      }
      return res.json();
    })
    .catch((err) => {
      console.error(err);
      return null;
    });
}
/* jscpd:ignore-end */
